import { BaseApiClient } from './base-client';
import { getAnonSessionId } from '../../utils/anonSession';

/**
 * Google Auth API - methods for Google OAuth2 authentication
 */
export class GoogleAuthApi extends BaseApiClient {

  /**
   * Get Google OAuth2 configuration (client ID, auth URL, state)
   */
  async getConfig(): Promise<{
    success: boolean;
    clientId?: string;
    redirectUri?: string;
    authUrl?: string;
    state?: string;
    error?: string;
  }> {
    const response = await this.client.get('/api/auth/google/config');
    return response.data;
  }

  /**
   * Exchange authorization code for session
   */
  async callback(code: string, state?: string): Promise<{
    success: boolean;
    sessionId: string;
    user: {
      id: string;
      googleId: string;
      email: string;
      username: string;
      firstName: string;
      lastName: string;
      avatarUrl: string;
      authType: string;
      tokens: number;
      subscriptionTier: string;
      created_at: string;
    };
    subscription: {
      tier: string;
      status: string;
      period: string;
      created_at: string;
      expires_at: string;
    };
  }> {
    // anonSessionId is required by the backend gate on the .ru segment
    // (verifies fresh registration consent before issuing a session).
    const anonSessionId = getAnonSessionId();
    const response = await this.client.post('/api/auth/google/callback', { code, state, anonSessionId });
    return response.data;
  }

  /**
   * Logout (delete session)
   */
  async logout(sessionId: string): Promise<{ success: boolean; message: string }> {
    const response = await this.client.post('/api/auth/google/logout', {}, {
      headers: { 'X-Session-ID': sessionId }
    });
    return response.data;
  }
}
